export default __webpack_public_path__ + "static/media/new-promo-offers-icon.0b63ed80.svg";